module.exports = __webpack_public_path__ + "static/media/ky.fa4b1eb4.svg";